import { PlaceStatus } from "../types/PlaceStatus";

export function placeStatusToText(status: PlaceStatus): string {
  switch (status) {
    case PlaceStatus.ACTIVE:
      return "Active";
    case PlaceStatus.PENDING:
      return "Pending";
    case PlaceStatus.REJECTED:
      return "Rejected";
    case PlaceStatus.OUT_OF_BUSINESS:
      return "Closed (Permanently)";
    case PlaceStatus.CLOSED_TEMPORARILY:
      return "Closed (Temporarily)";
    case PlaceStatus.NO_LONGER_HAS_POOL:
      return "No Pool";
    case PlaceStatus.UNDER_REVIEW:
      return "Under Review";
    case PlaceStatus.UNKNOWN:
      return "Unknown";
  }
}
